"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "next/link";
import { Heart } from "lucide-react";
import type { Dictionary } from "@/dictionaries/types";
import type { Collection } from "@/features/collections/types";
import { toCollectionView, useCollectionToggles } from "./collectionView";
import { ChainChip, CollectionCreator, CollectionLogo, CollectionName, CollectionToggles } from "./CollectionParts";
type Labels = Dictionary["browse"];
function LedgerRow(t0) {
  const $ = _c(73);
  const {
    collection,
    lang,
    rank,
    labels
  } = t0;
  let t1;
  if ($[0] !== collection || $[1] !== lang) {
    t1 = toCollectionView(collection, lang);
    $[0] = collection;
    $[1] = lang;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const v = t1;
  const t = useCollectionToggles(collection, lang);
  let num;
  let t10;
  let t11;
  let t12;
  let t13;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[3] !== labels.columnLikes || $[4] !== lang || $[5] !== rank || $[6] !== t.likeCount || $[7] !== v) {
    num = new Intl.NumberFormat(lang === "fa" ? "fa-IR" : "en-US");
    t8 = "v2-clx-row";
    t9 = rank <= 3 || undefined;
    t10 = <td className="v2-clx-td v2-clx-td-rank"><span className="v2-clx-rownum">{num.format(rank)}</span></td>;
    let t14;
    if ($[21] !== v) {
      t14 = <CollectionLogo v={v} size={46} />;
      $[21] = v;
      $[22] = t14;
    } else {
      t14 = $[22];
    }
    let t15;
    if ($[23] !== lang || $[24] !== v) {
      t15 = <CollectionName v={v} lang={lang} />;
      $[23] = lang;
      $[24] = v;
      $[25] = t15;
    } else {
      t15 = $[25];
    }
    let t16;
    if ($[26] !== t15 || $[27] !== v.href) {
      t16 = <Link className="v2-clx-row-link v2-focus" href={v.href}>{t15}</Link>;
      $[26] = t15;
      $[27] = v.href;
      $[28] = t16;
    } else {
      t16 = $[28];
    }
    let t17;
    if ($[29] !== lang || $[30] !== v) {
      t17 = <CollectionCreator v={v} lang={lang} />;
      $[29] = lang;
      $[30] = v;
      $[31] = t17;
    } else {
      t17 = $[31];
    }
    let t18;
    if ($[32] !== t16 || $[33] !== t17) {
      t18 = <span className="v2-clx-row-text">{t16}{t17}</span>;
      $[32] = t16;
      $[33] = t17;
      $[34] = t18;
    } else {
      t18 = $[34];
    }
    if ($[35] !== t14 || $[36] !== t18) {
      t11 = <th scope="row" className="v2-clx-td v2-clx-td-main"><span className="v2-clx-row-id">{t14}{t18}</span></th>;
      $[35] = t14;
      $[36] = t18;
      $[37] = t11;
    } else {
      t11 = $[37];
    }
    let t19;
    if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
      t19 = {
        objectFit: "cover"
      };
      $[38] = t19;
    } else {
      t19 = $[38];
    }
    if ($[39] !== v.banner) {
      t12 = <td className="v2-clx-td v2-clx-td-strip" aria-hidden={true}><span className="v2-clx-strip"><Image src={v.banner} alt="" fill={true} loading="lazy" sizes="140px" style={t19} /></span></td>;
      $[39] = v.banner;
      $[40] = t12;
    } else {
      t12 = $[40];
    }
    if ($[41] !== v) {
      t13 = <td className="v2-clx-td v2-clx-td-net"><ChainChip v={v} /></td>;
      $[41] = v;
      $[42] = t13;
    } else {
      t13 = $[42];
    }
    t7 = "v2-clx-td v2-clx-td-likes";
    t2 = "v2-clx-likes";
    t3 = t.likeCount > 0 ? undefined : true;
    if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <Heart aria-hidden={true} />;
      $[43] = t4;
    } else {
      t4 = $[43];
    }
    if ($[44] !== labels.columnLikes) {
      t5 = <span className="v2-sr-only">{labels.columnLikes}: </span>;
      $[44] = labels.columnLikes;
      $[45] = t5;
    } else {
      t5 = $[45];
    }
    t6 = t.likeCount > 0 ? num.format(t.likeCount) : "\u2014";
    $[3] = labels.columnLikes;
    $[4] = lang;
    $[5] = rank;
    $[6] = t.likeCount;
    $[7] = v;
    $[8] = num;
    $[9] = t10;
    $[10] = t11;
    $[11] = t12;
    $[12] = t13;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    num = $[8];
    t10 = $[9];
    t11 = $[10];
    t12 = $[11];
    t13 = $[12];
    t2 = $[13];
    t3 = $[14];
    t4 = $[15];
    t5 = $[16];
    t6 = $[17];
    t7 = $[18];
    t8 = $[19];
    t9 = $[20];
  }
  let t14;
  if ($[46] !== t2 || $[47] !== t3 || $[48] !== t4 || $[49] !== t5 || $[50] !== t6) {
    t14 = <span className={t2} data-empty={t3}>{t4}{t5}{t6}</span>;
    $[46] = t2;
    $[47] = t3;
    $[48] = t4;
    $[49] = t5;
    $[50] = t6;
    $[51] = t14;
  } else {
    t14 = $[51];
  }
  let t15;
  if ($[52] !== t14 || $[53] !== t7) {
    t15 = <td className={t7}>{t14}</td>;
    $[52] = t14;
    $[53] = t7;
    $[54] = t15;
  } else {
    t15 = $[54];
  }
  const t16 = v.standard || "\u2014";
  let t17;
  if ($[55] !== t16) {
    t17 = <td className="v2-clx-td v2-clx-td-std v2-clx-dim">{t16}</td>;
    $[55] = t16;
    $[56] = t17;
  } else {
    t17 = $[56];
  }
  const t18 = v.created || "\u2014";
  let t19;
  if ($[57] !== t18) {
    t19 = <td className="v2-clx-td v2-clx-td-date v2-clx-dim">{t18}</td>;
    $[57] = t18;
    $[58] = t19;
  } else {
    t19 = $[58];
  }
  let t20;
  if ($[59] !== num || $[60] !== t) {
    t20 = <td className="v2-clx-td v2-clx-td-watch"><CollectionToggles t={t} num={num} only="watch" /></td>;
    $[59] = num;
    $[60] = t;
    $[61] = t20;
  } else {
    t20 = $[61];
  }
  let t21;
  if ($[62] !== t10 || $[63] !== t11 || $[64] !== t12 || $[65] !== t13 || $[66] !== t15 || $[67] !== t17 || $[68] !== t19 || $[69] !== t20 || $[70] !== t8 || $[71] !== t9) {
    t21 = <tr className={t8} data-podium={t9}>{t10}{t11}{t12}{t13}{t15}{t17}{t19}{t20}</tr>;
    $[62] = t10;
    $[63] = t11;
    $[64] = t12;
    $[65] = t13;
    $[66] = t15;
    $[67] = t17;
    $[68] = t19;
    $[69] = t20;
    $[70] = t8;
    $[71] = t9;
    $[72] = t21;
  } else {
    t21 = $[72];
  }
  return t21;
}

/**
 * THE /collection TABLE — the legacy table's six columns and its watchlist
 * toggle, set as a ledger: a gold rank numeral, the collection with its
 * creator, a strip of its banner on wide screens, then the facts. The like
 * count reads the shared interaction state, so it moves with a like made in
 * the grid. Narrower screens drop the columns a phone reader does not
 * scan for — the strip below 1280px, standard and date below 1024px — and
 * below 768px the row re-flows into a ranked list line: rank, the
 * collection, then network over likes, then the watch toggle.
 */
export default function CollectionsLedger(t0) {
  const $ = _c(37);
  const {
    items,
    lang,
    labels,
    firstRank
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <th scope="col" className="v2-clx-th v2-clx-td-rank">#</th>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== labels.columnCollection) {
    t2 = <th scope="col" className="v2-clx-th v2-clx-td-main">{labels.columnCollection}</th>;
    $[1] = labels.columnCollection;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== labels.columnCollection) {
    t3 = <th scope="col" className="v2-clx-th v2-clx-td-strip"><span className="v2-sr-only">{labels.columnCollection}</span></th>;
    $[3] = labels.columnCollection;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== labels.columnNetwork) {
    t4 = <th scope="col" className="v2-clx-th v2-clx-td-net">{labels.columnNetwork}</th>;
    $[5] = labels.columnNetwork;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== labels.columnLikes) {
    t5 = <th scope="col" className="v2-clx-th v2-clx-td-likes">{labels.columnLikes}</th>;
    $[7] = labels.columnLikes;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== labels.columnStandard) {
    t6 = <th scope="col" className="v2-clx-th v2-clx-td-std">{labels.columnStandard}</th>;
    $[9] = labels.columnStandard;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== labels.columnCreated) {
    t7 = <th scope="col" className="v2-clx-th v2-clx-td-date">{labels.columnCreated}</th>;
    $[11] = labels.columnCreated;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== labels.watchlistColumn) {
    t8 = <th scope="col" className="v2-clx-th v2-clx-td-watch"><span className="v2-sr-only">{labels.watchlistColumn}</span></th>;
    $[13] = labels.watchlistColumn;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t2 || $[16] !== t3 || $[17] !== t4 || $[18] !== t5 || $[19] !== t6 || $[20] !== t7 || $[21] !== t8) {
    t9 = <thead><tr>{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}</tr></thead>;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== firstRank || $[24] !== items || $[25] !== labels || $[26] !== lang) {
    let t11;
    if ($[28] !== firstRank || $[29] !== labels || $[30] !== lang) {
      t11 = (c, i) => <LedgerRow key={c.id} collection={c} lang={lang} rank={firstRank + i} labels={labels} />;
      $[28] = firstRank;
      $[29] = labels;
      $[30] = lang;
      $[31] = t11;
    } else {
      t11 = $[31];
    }
    t10 = items.map(t11);
    $[23] = firstRank;
    $[24] = items;
    $[25] = labels;
    $[26] = lang;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[32] !== t10) {
    t11 = <tbody>{t10}</tbody>;
    $[32] = t10;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  let t12;
  if ($[34] !== t11 || $[35] !== t9) {
    t12 = <div className="v2-clx-ledger"><table>{t9}{t11}</table></div>;
    $[34] = t11;
    $[35] = t9;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  return t12;
}